import { useMutation } from '@apollo/client';
import { UPDATE_CATEGORY } from '../graphql';
import { UpdateCategory, UpdateCategoryVariables } from '../graphql-types/UpdateCategory';

export const useUpdateCategory = () => {
  const [mutate, state] = useMutation<
    UpdateCategory,
    UpdateCategoryVariables
  >(UPDATE_CATEGORY, {
    refetchQueries: ['GetCategories'],
  });

  const updateCategory = async (input: { _id: string; name: string }) => {
    const { data } = await mutate({
      variables: { input },
    });

    if (!data?.updateCategory.success) {
      throw new Error(data?.updateCategory.message || 'Update failed');
    }

    return data.updateCategory;

  };

  return {
    updateCategory,
    ...state,
  };
};